<template>
  <div class="d-flex flex-column" style="min-height: 100vh">
    <v-container fluid class="ma-0 pa-0">
      <Navigation width="100%" v-if="!$vuetify.breakpoint.xs"/>
      <MobileNavBar v-else/>
      <div :style="{ marginTop: $vuetify.breakpoint.xs ? '15vh' : '8vh'}">
        <NotFound />
      </div>
    </v-container>
    <div class="mt-auto">
      <Footer />
    </div>
  </div>
</template>

<script>
import Navigation from "@/components/Navigation.vue";
import Footer from "@/components/Footer";
import NotFound from "@/components/NotFound";
import MobileNavBar from "@/components/MobileNavBar";

export default {
  components: {
    MobileNavBar,
    Navigation,
    Footer,
    NotFound,
  },
  data: () => ({
    description:
      "Guiomentor is a platform directed to a niche of 10 to 25 years old. Its objective is to help students to choose the best career or discipline for them according to their skills and part of interest ",
  }),
  metaInfo() {
    return {
      title: "Home - Guiomentor 404",
      url: window.location.href,
      meta: [
        { name: "title", content: "Guiomentor" },
        { name: "description", content: this.description },
        //Facebook
        { name: "og:type", content: "Website" },
        { name: "og:title", content: "Guiomentor" },
        { name: "og:description", content: this.description },
        { name: "og:image", content: this.logo },

        // Twitter
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:url", content: window.location.href },
        { name: "twitter:title", content: "Guiomentor" },
        { name: "twitter:description", content: this.description },
        { name: "twitter:image", content: this.logo },
      ],
    };
  },
};
</script>

<style>
</style>
